<template>
  <span class="audio-player-container">
    <img
      :width="hideProgressBar ? '50px' : '25px'"
      :height="hideProgressBar ? '50px' : '25px'"
      :src="
        audio && audio.paused
          ? require('../../assets/svg/play2.svg').default
          : require('../../assets/svg/pause.svg').default
      "
      @click="play"
      :class="{ disabledBtn: !audioFile }"
    />
    <button
      v-if="!hideProgressBar && audioFile"
      class="speed-btn"
      @click="cycleSpeed"
      :title="`מהירות: ${playbackRate}x`"
    >
      {{ playbackRate }}x
    </button>
    <input
      v-if="!hideProgressBar"
      type="range"
      ref="progressBar"
      name="progressBar"
      id="progressBar"
      class="slider"
      :value="progressBar"
      @input="changeProgress"
    />
  </span>
</template>

<script>
import "./AudioPlayer.scss";
import { audioService } from "../../services/audioService";
import { settingsService } from "../../services/settingsService";
export default {
  name: "AudioPlayer",
  data() {
    return {
      audioFile: null,
      audio: null,
      progressBar: 0,
      isPlaying: null,
      soundSetting: null,
      speakSetting: null,
      playbackRate: 1,
      availableSpeeds: [1, 1.25, 1.5, 2]
    };
  },
  props: {
    urlId: {
      type: String | Number,
      require: false
    },
    hideProgressBar: {
      type: Boolean,
      default: false
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    audioSrc: { type: String, required: true }
  },
  async created() {
    this.soundSetting = await settingsService.getSettings();
    this.loadSavedSpeed();
  },
  mounted() {
    console.log(this.hideProgressBar);
    if (this.urlId) {
      this.getAudio();
    } else {
      this.audioFile = this.audioSrc;
    }
  },
  beforeDestroy() {
    this.audio.pause();
  },
  watch: {
    urlId() {
      // this.isStop = true;
      this.getAudio();
    },
    audioFile() {
      this.makeAudio(this.audioFile);
    },
    soundSetting() {
      if (this.soundSetting && this.soundSetting.length) {
        this.speakSetting = this.soundSetting[1];
      }
      if (this.audio && this.autoPlay && this.speakSetting) this.play();
    },
    audio() {
      console.log(this.speakSetting);
      if (this.autoPlay && this.speakSetting) this.play();
    },
    progressBar() {
      this.$refs.progressBar.style.backgroundSize =
        ((this.progressBar - 0) * 100) / (100 - 0) + "% 100%";
    },
    $route(to, from) {
      this.audio.pause();
    }
  },
  methods: {
    getAudio() {
      if (this.urlId) {
        audioService.playAudio(this.urlId).then(async res => {
          const { mediaUrl } = await res.json();
          this.audioFile = mediaUrl;

          //this.makeAudio(this.audioFile);
          // if (this.autoplay) {
          //   this.isStop = false;
          //   this.playAudio();
          // }
        });
      } else {
        this.audioFile = null;
      }
    },
    changeProgress(e) {
      if (this.audio)
        this.audio.currentTime = (this.audio.duration / 100) * e.target.value;
      const el = e.target;
      console.log(((el.value - 0) * 100) / (100 - 0) + "% 100%");
      el.style.backgroundSize = ((el.value - 0) * 100) / (100 - 0) + "% 100%";
    },
    play(e) {
      console.log(this.audio.paused);
      if (e) e.stopPropagation();
      if (!this.audio.paused) {
        this.audio.pause();
      } else {
        this.audio.play();
      }
    },
    pause() {
      this.audio.pause();
    },
    makeAudio(audioFile) {
      this.audio = new Audio(audioFile);

      this.audio.volume = 0.5;
      this.audio.playbackRate = this.playbackRate;
      this.audio.addEventListener("timeupdate", e => {
        this.progressBar = (this.audio.currentTime / this.audio.duration) * 100;
      });

      this.audio.addEventListener("ended", () => {
        this.audio.currentTime = 0;
        this.audio.pause();
      });
    },
    cycleSpeed() {
      const currentIndex = this.availableSpeeds.indexOf(this.playbackRate);
      const nextIndex = (currentIndex + 1) % this.availableSpeeds.length;
      this.playbackRate = this.availableSpeeds[nextIndex];
      
      if (this.audio) {
        this.audio.playbackRate = this.playbackRate;
      }
      
      // שמירת המהירות ב-localStorage
      localStorage.setItem('audioPlaybackRate', this.playbackRate);
    },
    loadSavedSpeed() {
      const savedRate = localStorage.getItem('audioPlaybackRate');
      if (savedRate && this.availableSpeeds.includes(parseFloat(savedRate))) {
        this.playbackRate = parseFloat(savedRate);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// AudioPlayer.vue?17c0fac6